import { forwardRef, type Ref, type SVGProps } from "react";
const IconCafeOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 44 44"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M8.25 11.324c.028 14.615 1.375 23.051 8.25 23.051h8.25c4.426 0 6.549-3.42 7.514-9.675 1.626-.132 3.08-.543 4.194-1.472 1.47-1.225 2.042-3.08 2.042-5.353 0-1.221-.255-2.266-.791-3.117-.542-.86-1.299-1.41-2.105-1.756-.817-.35-1.734-.505-2.609-.574q.004-.546.005-1.104c.003-1.697-1.23-3.074-2.748-3.074H10.999c-1.52 0-2.752 1.377-2.749 3.074m5.94 19.493c.533.497 1.214.808 2.31.808h8.25c1.123 0 1.813-.316 2.346-.811.605-.562 1.224-1.563 1.743-3.28 1.057-3.496 1.397-8.873 1.411-16.215a.53.53 0 0 0-.09-.319H11.09a.53.53 0 0 0-.09.319c.014 7.334.372 12.713 1.438 16.21.524 1.718 1.145 2.723 1.752 3.288m20.508-9.701c-.44.367-1.103.641-2.092.78.19-2.015.298-4.257.352-6.71.595.053 1.121.154 1.563.343.397.17.671.393.86.694.195.308.369.81.369 1.652 0 1.852-.46 2.747-1.052 3.24"
      clipRule="evenodd"
    />
    <path d="M9.625 35.75a1.375 1.375 0 1 0 0 2.75h22a1.375 1.375 0 1 0 0-2.75z" />
  </svg>
);
const ForwardRef = forwardRef(IconCafeOutlineSVG);
ForwardRef.displayName = "IconCafeOutline";
export { ForwardRef as IconCafeOutline };
